import { UploadErrorCode } from '@fabric-app/types/upload';
import { UploadError } from '../upload.error.js';
import { xhrGetHeaders } from './xhrGetHeaders.js';

const executeXHRUpload = async ({ method, url, headers, onProgress, abortSignal, file }) => {
  return new Promise((resolve, reject) => {
    let progressTimeout;
    const xhr = new XMLHttpRequest();
    xhr.open(method, url);
    Object.entries(headers).forEach(([key, value]) => {
      xhr.setRequestHeader(key, value);
    });
    let lastProgress = 0;
    const onProgressCallback = (loaded, total) => {
      lastProgress = loaded / total * 100;
      if (onProgress) {
        onProgress(loaded, total);
      }
    };
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        onProgressCallback(event.loaded, event.total);
        if (progressTimeout) clearTimeout(progressTimeout);
        progressTimeout = window.setTimeout(() => {
          if (lastProgress < 100) {
            xhr.abort();
            throw new UploadError(UploadErrorCode.Timeout);
          }
        }, 3e4);
      }
    };
    xhr.onload = () => {
      if (progressTimeout) clearTimeout(progressTimeout);
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve({
          responseHeaders: xhrGetHeaders(xhr)
        });
      } else {
        reject(new UploadError(UploadErrorCode.FileUploadFailed, `Upload failed with status ${xhr.status}`, true, false));
      }
    };
    xhr.onerror = () => {
      if (progressTimeout) clearTimeout(progressTimeout);
      reject(new UploadError(UploadErrorCode.FileUploadFailed, "Network error during upload", true, false));
    };
    xhr.onabort = () => {
      if (progressTimeout) clearTimeout(progressTimeout);
      reject(new UploadError(UploadErrorCode.FileUploadFailed, "Upload aborted", true, false));
    };
    xhr.send(file);
    if (abortSignal) {
      abortSignal.addEventListener("abort", () => xhr.abort());
    }
  });
};

export { executeXHRUpload };
//# sourceMappingURL=executeXHRUpload.js.map
